import React, { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import { collection, addDoc } from "firebase/firestore/lite";
import { serverTimestamp } from "firebase/firestore/lite";
import { useHistory } from "react-router-dom";
import db from "./Firebase";
import { Modal } from "react-bootstrap";
import GoogleButton from "react-google-button";
import { UserAuth } from "../context/AuthContext";

const CreatePost = () => {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [name, setName] = useState("");
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const history = useHistory();
  const sendIt = async (e) => {
    e.preventDefault();
    if (title == "" || content == "" || name == "") {
      alert("Please fill all the fields!");
    } else if (content.length < 100) {
      alert("please enter minimum 100 letters");
    } else {
      await addDoc(collection(db, "blogpost"), {
        Name: name,
        Title: title,
        Content: content,
        timestamp: serverTimestamp(),
      })
        .then(function (res) {
          alert("Data is sucessfully added");
          setName("");
          setTitle("");
          setContent("");
          history.push("/");
        })
        .catch(function (err) {
          console.log(err);
          alert(err);
        });
    }
  };
  const { googleSignIn, user } = UserAuth();
  const handleGoogleAuth = async (e) => {
    try {
      e.preventDefault();
      await googleSignIn();
      handleClose();
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    if (user == null) {
      handleShow();
    } else {
      setName(user.displayName);
    }
  }, [user]);
  return (
    <div>
      <div className="container my-4 form-container">
        <Button
          variant="primary"
          type="submit"
          className="signin-btn"
          onClick={handleShow}
        >
          {user != null ? "Signed In" : "Sign In"}
        </Button>
        <Form>
          <Form.Group
            controlId="exampleForm.ControlInput1"
            className="createpost-input mb-3"
          >
            <Form.Label>Name</Form.Label>
            <Form.Control
              autoComplete="off"
              color="danger"
              type="text"
              placeholder="Your name..."
              onChange={(e) => setName(e.target.value)}
              value={name}
            />
          </Form.Group>
          <Form.Group
            controlId="exampleForm.ControlInput1"
            className="createpost-input mb-3"
          >
            <Form.Label>Title</Form.Label>
            <Form.Control
              autoComplete="off"
              type="text"
              placeholder="Title..."
              onChange={(e) => setTitle(e.target.value)}
              value={title}
            />
          </Form.Group>
          <Form.Group
            controlId="exampleForm.ControlTextarea1"
            className="createpost-textarea mb-3"
          >
            <Form.Label>Content</Form.Label>
            <Form.Control
              autoComplete="off"
              as="textarea"
              rows={6}
              onChange={(e) => setContent(e.target.value)}
              value={content}
            />
            <Button
              variant="primary"
              type="submit"
              className="submit-btn"
              onClick={sendIt}
            >
              Post
            </Button>
          </Form.Group>
        </Form>
      </div>
      <Modal show={show} onHide={handleClose} backdrop="static">
        <Modal.Header>
          <Modal.Title>
            Sign In
            <Button
              variant="primary"
              type="submit"
              className="back-btn"
              onClick={() => history.push("/")}
            >
              Back to post
            </Button>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <GoogleButton onClick={handleGoogleAuth} />
        </Modal.Body>
      </Modal>
      <div className="footer1">
        Developed by{" "}
        <a href="https://github.com/Praveen-webdev" className="anchor">
          {" "}
          Praveen
        </a>
      </div>
    </div>
  );
};
export default CreatePost;
